import { ReactElement } from 'react';
import { getLabelFallback } from '@utils/utils';

import Loader from '@components/Loader';

const CartLoader = () : ReactElement => {
    return(
        <div className="cart-loader">
            <Loader classes={"white"}/>
            <label className="cart-loader-label">{getLabelFallback('LOADING_LABEL')}</label>
        </div>
    )
}

export default CartLoader;